// post-message.service.ts
import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PostMessageService {
  private messageSubject = new Subject<any>();

  constructor() {
    window.addEventListener('message', this.handleMessage.bind(this));
  }

  private handleMessage(event: MessageEvent): void {
    this.messageSubject.next(event.data);
  }

  getMessage(): Observable<any> {
    return this.messageSubject.asObservable();
  }
}
